<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/expertteam' }"
        >专家咨询</el-breadcrumb-item
      >
      <el-breadcrumb-item>专家团队</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="title">专家咨询</div>
        <div class="consult">
          <div class="headline">咨询方向：</div>
          <div class="headline_box" v-for="(it, ind) in Types" :key="ind">
            {{ it.name }}
          </div>
        </div>
        <div class="Teacher_Information">
          <div
            class="Teacher_box"
            @click="goDetails(it.id)"
            v-for="(it, ind) in list"
            :key="ind"
          >
            <!-- 左侧头像 -->
            <div class="php">
              <img :src="it.pic" alt="" />
            </div>
            <div class="center">
              <div class="top">
                <div class="name">{{ it.name }}</div>
                <div class="years">
                  <span class="h">资历：</span>
                  <span class="z">{{ it.serviceExpres }}</span>
                  服务经验
                </div>
              </div>
              <div class="btn">
                <div>{{ it.majorTag }}</div>
              </div>
            </div>
            <div class="right">
              <div class="imgs"><img src="./images/wx.png" alt="" /></div>
              <div class="link">立即咨询</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetType, GetList } from "@/api/home";
export default {
  name: "XExpertteam",

  data() {
    return {
      Types: "",
      list: "",
    };
  },

  async mounted() {
    const res = await GetType("340820674089029");
    const resa = await GetList();
    this.Types = res.data||res.result;
    this.list = resa.data||resa.result;
  },

  methods: {
    goDetails(id) {
      this.$router.push({ path: "/Details", query: { id } });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/global.less";
.box {
  width: 100%;
  background-color: #fff;
  min-width: 1050px;
  .content {
    margin-left: 30px;
    .title {
      font-size: 22px;
      font-weight: bold;
      margin: 25px 0 30px 0;
      padding-top: 25px;
    }
    .consult {
      display: flex;
      align-items: center;
      .headline {
        font-size: 20px;
      }
      .headline_box {
        width: 109px;
        height: 32px;
        border-radius: 38px 38px 38px 38px;
        border: 1px solid #f99f39;
        color: #666;
        font-size: 20px;
        line-height: 32px;
        text-align: center;
        margin-left: 34px;
      }
    }
    .Teacher_Information {
      margin-top: 38px;
      .Teacher_box {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 60px;
        width: 90%;
        height: 133px;
        background: #f5f8ff;
        box-shadow: 0px 1px 10px 2px #f5f8ff;
        border-radius: 3px 3px 3px 3px;
        opacity: 1;
        box-sizing: border-box;
        .php {
          width: 100px;
          height: 100px;
          margin-left: 18px;
          opacity: 1;
          border-radius: 50%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .center {
          display: flex;
          flex-direction: column;
          padding-right: 20%;
          box-sizing: border-box;
          .top {
            display: flex;
            text-align: center;
            align-items: center;
            .name {
              font-size: 28px;
              font-weight: 800;
              color: #333;
              margin-right: 10px;
            }
            .years {
              font-size: 20px;
              color: #666666;
              .z {
                color: #7a55ff;
              }
            }
          }
          .btn {
            margin-top: 19px;
            display: flex;
            div {
              font-size: 20px;
              color: @blues;
              margin-right: 35px;
            }
          }
        }
        .right {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 160px;
          height: 49px;
          background: #fffdfa;
          border-radius: 7px 7px 7px 7px;
          opacity: 1;
          margin-right: 43px;
          .imgs {
            width: 28px;
            height: 28px;
            line-height: 28px;
            text-align: center;
          }
          .link {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>